import { useCallback } from "react";
import { MenuItem, Tooltip } from "@mui/material";
import { isCalendarPresetTimeWindow } from "../../../../TimeWindow.calendarPresets";
import type { TimeWindowRangePresetOptionProps } from "./TimeWindowRangePresetOption.types";

const TimeWindowRangePresetOption = ({
  label,
  tooltip,
  presetId,
  tzCtx,
  timeWindow,
  setTimeWindow,
  onSelect,
}: TimeWindowRangePresetOptionProps) => {
  const handleSelect = useCallback(() => {
    setTimeWindow(presetId);
    onSelect?.(presetId);
  }, [onSelect, presetId, setTimeWindow]);

  return (
    <Tooltip arrow placement="left" title={tooltip}>
      <MenuItem
        data-test-id="time-window-option"
        value={presetId}
        selected={isCalendarPresetTimeWindow(timeWindow, tzCtx, presetId)}
        onClick={handleSelect}
        className="gap-0.5 justify-between! pr-8! relative grid grid-cols-[auto_1fr] items-center"
      >
        {label}
      </MenuItem>
    </Tooltip>
  );
};

export default TimeWindowRangePresetOption;
